'use client';

import { useAppContext } from 'context/state';
import { verifyEmail } from 'features/auth/actions';
import { AuthVerifyParamsDto } from 'features/auth/model/auth.dto';
import { AuthVerifyFormState } from 'features/auth/model/auth.form';
import BaseTextForm from 'features/auth/ui/BaseTextForm';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';
import { useEffect, useMemo } from 'react';
import { CookiesType, Routes, SnackbarType } from 'types/enums';
import { z } from 'zod';

const EmailAuthForm = () => {
  const { showSnackbar } = useAppContext();
  const router = useRouter();
  const t = useTranslations();

  const emailSchema = useMemo(
    () =>
      z.object({
        email: z
          .string({
            required_error: t('required_field'),
          })
          .email(t('incorrect_email_format')),
      }),
    [t],
  );

  const onActionSuccess = (state: AuthVerifyFormState) => {
    router.push(`${Routes.AuthVerify}?${new URLSearchParams(state.data).toString()}`);
  };

  const onActionError = (_state: AuthVerifyFormState) => {
    showSnackbar(t('Auth.verificationCodeSendError'), SnackbarType.error);
  };

  useEffect(() => {
    Cookies.remove(CookiesType.refreshToken);
    Cookies.remove(CookiesType.accessToken);
  }, []);

  return (
    <BaseTextForm
      action={(data) => verifyEmail(data as AuthVerifyParamsDto)}
      schema={emailSchema}
      inputProps={{
        inputMode: 'email',
        autoComplete: 'email',
        type: 'email',
        label: t('Auth.emailLabel'),
        name: 'email',
      }}
      defaultValues={{
        email: '',
      }}
      onActionSuccess={onActionSuccess}
      onActionError={onActionError}
    />
  );
};

export default EmailAuthForm;
